import { createSlice } from "@reduxjs/toolkit";

const jobsSearch = createSlice({
  name: "jobsSearch",
  initialState: {
    jobSearchData: {
      searchDto: {
        search: "",
        pageSize: 12,
        pageNumber: 1,
        sortBy: "1",
        isSortAsc: true,
      },
      jobSearchDto: {
        jobTitle: "",
        city: "",
        cooperationType: -1,
      },
    },
  } as any,
  reducers: {
    resetFilters(state) {
      state.jobSearchData = {
        searchDto: {
          search: "",
          pageSize: 12,
          pageNumber: 1,
          sortBy: "1",
          isSortAsc: true,
        },
        jobSearchDto: {
          jobTitle: "",
          city: "",
          cooperationType: -1,
        },
      };
    },
    setJobSearchData(state, { payload }) {
      state.jobSearchData = payload;
    },
  },
});

export const { resetFilters, setJobSearchData } = jobsSearch.actions;

export default jobsSearch.reducer;
